import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Form } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import api from '../../services/api';
import styles from '../../services/styles';
import { displayMessage } from '../../helpers/messages';
import Button from '../../components/buttons/Button';
import Input from '../../components/input/Input';
import { showErrorMessage, showSuccessMessage } from '../../services/messages';

const { COLORS } = styles;

export const ResetPasswordForm = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    if (values.password !== values.confirmPassword) {
      showErrorMessage(displayMessage('ERROR_PASSWORD_MISMATCH'));
      return;
    }

    setLoading(true);

    try {
      await api.auth.resetPasswordForced({
        password: values.password
      }, token);

      showSuccessMessage(displayMessage('SUCCESS_PASSWORD_RESET'));

      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (error) {
      showErrorMessage(error?.response?.data?.error || displayMessage('ERROR_GENERIC'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div
        style={{
          fontWeight: 'bold',
          marginBottom: 15,
          fontSize: 24,
          textShadow: '#777 1px 2px 1px, 0px 2px 1px rgb(0 0 0 / 0%)',
          color: COLORS.SECONDARY,
          textAlign: 'center'
        }}
      >
        {displayMessage('RESET_PASSWORD')}
      </div>

      <Form
        name="reset_password"
        onFinish={onFinish}
        style={{ maxWidth: 400, width: '100%' }}
        layout='vertical'
        requiredMark={false}
      >
        <div style={{ display: 'flex', gap: 2, flexDirection: 'column' }}>
          <div
            style={{
              color: COLORS.GRAY[50],
              textShadow: '#777 1px 2px 1px, 0px 2px 1px rgb(0 0 0 / 0%)',
              fontWeight: 'bold',
              display: 'flex'
            }}>
            {displayMessage('NEW_PASSWORD')}
          </div>

          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Por favor, informe a nova senha!' }]}
            style={{ marginBottom: 15 }}
          >
            <Input
              prefix={<LockOutlined className="site-form-item-icon" />}
              type="password"
              placeholder="Digite a nova senha"
            />
          </Form.Item>
        </div>

        <div style={{ display: 'flex', gap: 2, flexDirection: 'column', marginTop: 5 }}>
          <div
            style={{
              color: COLORS.GRAY[50],
              textShadow: '#777 1px 2px 1px, 0px 2px 1px rgb(0 0 0 / 0%)',
              fontWeight: 'bold',
              display: 'flex'
            }}>
            {displayMessage('CONFIRM_PASSWORD')}
          </div>

          <Form.Item
            name="confirmPassword"
            rules={[{ required: true, message: 'Por favor, confirme a senha!' }]}
            style={{ marginBottom: 25 }}
          >
            <Input
              prefix={<LockOutlined className="site-form-item-icon" />}
              type="password"
              placeholder="Confirme a nova senha"
            />
          </Form.Item>
        </div>

        <Form.Item style={{ marginBottom: 10, marginTop: 5 }}>
          <Button
            type="primary"
            style={{
              width: "100%",
              fontWeight: 'bold',
              textShadow: '0px 0px 5px #666',
            }}
            htmlType="submit"
            loading={loading}
          >
            {displayMessage('CONFIRM')}
          </Button>
        </Form.Item>

        <Form.Item style={{ margin: 0 }}>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              style={{
                color: COLORS.SECONDARY,
                fontWeight: 'bold',
                textShadow: '#777 1px 2px 1px, 0px 2px 1px rgb(0 0 0 / 0%)',
              }}
              type="link"
              onClick={() => navigate('/login')}
            >
              Voltar para o Login
            </Button>
          </div>
        </Form.Item>
      </Form>
    </>
  );
};



